import ServiceCategoryPage from "../components/ServiceCategoryPage";
import gardeningService from "../data/services/gardeningService";

function Gardening() {
  return <ServiceCategoryPage service={gardeningService} />;
}

export default Gardening;